module.exports = "/_next/static/images/heartinhand-monotone-81be3dccf67a5f8d5d34876176acfd6e.svg";